module.exports = __webpack_public_path__ + "img/desc3.70ede2d0.jpg";